// v2/utils/format.js  — Turkce sayi/para bicimlendirme
const nf = (min, max) =>
  new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  });

/** null / undefined / '' degerleri sayi sayilmaz — Number(null) 0 veriyor */
const bosMu = (v) => v === null || v === undefined || v === '';

export const formatNumber = (v, d = 0) => {
  if (bosMu(v)) return '-';
  const n = Number(v);
  return Number.isFinite(n) ? nf(d, d).format(n) : '-';
};

/** 349.2 -> "349,20 ₺" */
export const formatTRY = (v) => {
  if (bosMu(v)) return '- ₺';
  const n = Number(v);
  return Number.isFinite(n) ? `${nf(2, 2).format(n)} ₺` : '- ₺';
};

/** 1250430 -> "1.250.430 ₺" */
export const formatTRYShort = (v) => {
  if (bosMu(v)) return '- ₺';
  const n = Number(v);
  return Number.isFinite(n) ? `${nf(0, 0).format(n)} ₺` : '- ₺';
};

/** 27.04 -> "%27,04" */
export const formatPercent = (v, d = 2) => {
  if (bosMu(v)) return '-';
  const n = Number(v);
  return Number.isFinite(n) ? `%${nf(d, d).format(n)}` : '-';
};

/** 1500000 -> "1.5M" (grafik ekseni icin) */
export const formatCompact = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '';
  if (Math.abs(n) >= 1_000_000) return `${nf(0, 1).format(n / 1_000_000)}M`;
  if (Math.abs(n) >= 1_000) return `${nf(0, 0).format(n / 1_000)}K`;
  return nf(0, 0).format(n);
};
